import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';
import { API_URL_COMPANIES, API_URL_PREFIX } from 'src/app/shared/services/basic.service';

@Injectable({
  providedIn: 'root',
})
export class UserPreferencesAccessCheckService {
  id = 0;

  constructor(private httpClient: HttpClient, private alcmeonContextService: AlcmeonContextService) {}

  getUuid() {
    const uuid = this.id;
    this.id++;
    return uuid;
  }

  getAlcmeonApp() {
    return this.httpClient.get(`${API_URL_PREFIX}/v3`).pipe(
      catchError(e => {
        // Do not interpret as a json.
        if (e.status === 200 && e.statusText === 'OK') {
          return of(true);
        }
        throwError(e);
      })
    );
  }

  postWSNotification(data) {
    return this.httpClient.post(`${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/ws-notification`, data);
  }
}
